// From http://stackoverflow.com/questions/29421409/how-to-load-all-files-in-a-subdirectories-using-webpack-without-require-statemen
function requireAll(r) { r.keys().forEach(r); }
requireAll(require.context('./fonts/', true, /(otf|ttf|woff|woff2)$/));
